export enum EnvironmentType {
  Dev = 0,
  SIT = 1,
  UAT = 2,
  Staging = 3,
  Production = 4,
}

export enum ApplipcationStoreType {
  Peak = 0,
  NewPeak = 1,
  Payroll = 2,
  Board = 3,
  Asset = 4,
  Tax = 5,
}

export enum LoadingStatusType {
  None = 0,
  Loading = 1,
  Success = 2,
  Fail = 3,
}

export enum Locales {
  EN = "en",
  TH = "th",
}
export enum LanguageType {
  Th = 0,
  En = 1,
}

export enum ChangeFormType {
  None = 0,
  DayOnDay = 1,
  WeakOnWeak = 2,
  MonthOnMonth = 3,
  QuarterOnQuarter = 4,
  YearOnYear = 5,
}

export enum TypeComponentNoti {
  Success = 1,
  Warn = 2,
  Error = 3,
  Upload = 4,
}

export enum Role {
  None = 0,
  ViewOnly = 1, // ดูได้อย่างเดียว
  PartialRightsDraftOnly = 2, //สิทธิบางส่วน ร่างได้อย่างเดียว
  PartialRightsApproveAndReceivePayment = 3, //สิทธิบางส่วน อนุมัติและรับจ่าย
  PartialRightsRevenueOnly = 4, //สิทธิบางส่วน ฝั่งรายได้อย่างเดียว
  PartialRightsExpenseOnly = 5, //สิทธิบางส่วน ฝั่งรายจ่ายอย่างเดียว
  PartialRightsQuotationOnly = 6, //สิทธิบางส่วน ใบเสนอราคาอย่างเดียว
  StandardRightsViewReport = 7,
  StandardRightsNotViewReport = 8,
  Admin = 9,
}

export enum NotificationMessageType {
  None = 0,
  Quotation = 1,
  PurcahseOrder = 2,
  Invoice = 3,
  InvoiceAllProduct = 4,
  Expense = 5,
  ExpenseAllProduct = 6,
  PurchaseAsset = 7,
  PurchaseAssetAllProduct = 8,
  Receipt = 9,
  StockActivityStockCardMovement = 10,
  TaxInvoice = 11,
  TaxInvoiceInRevenueDepartmentFormat = 12,
  TrialBalanceWithSubAccount = 13,
  TrialBalance = 14,
  PurcahseTaxInvoice = 15,
  PurchaseTaxInvoiceInRevenueDepartFormat = 16,
  Journal = 17,
  BillingNoteInvoice = 18,
  BillingNoteInvoiceAllInvoice = 19,
  BillingNoteExpense = 20,
  BillingNoteExpenseAllExpense = 21,
  Finance = 22,
  PP30InputVat = 23,
  PP30OutputVat = 24,
  CreditNote = 25,
  CreditNoteExpense = 26,
  AssetTemplateGroup = 27,
  AssetTemplate = 28,
  WithHeldTax = 29,
  WithHoldingTax = 30,
  GeneralLedgerTransaction = 31,
  AllGeneralLedger = 32,
  AllGeneralLedgerWithSubAccount = 33,
  AgingReportAR = 34,
  AgingReportAP = 35,
  Product = 36,
  ProfitLoss = 37,
  ChartOfAccount = 38,
  BalanceSheet = 39,
  Unit = 40,
  ReportDocument = 41,
  Asset = 42,
  StatementEFiling = 43,
  AllReport = 44,
  Contact = 45,
  PurchaseTaxInvoiceNotUse = 46,
  SalesTaxInvoiceNotUse = 47,
  PP30TaxFilingTextFile = 48,
  WithHoldingTaxPND2 = 49,
  WithHoldingTaxPND3 = 50,
  WithHoldingTaxPND53 = 51,
  CashflowStatementReport = 52,
  AllReportSalesByCustomerReport = 53,
  AllReportSalesByAccountReport = 54,
  AllReport_RemainingFinanceBalanceReport = 55,
  StatementEFilingExcel = 56,
  AllReportProductSalesByContact = 57,
  AllReport_ProductServiceSalesSummaryReportOnDailyAccount = 58,
  Pnd53TaxFilingTextFile = 59,
  Pnd3TaxFilingTextFile = 60,
  DailyJournal = 61,
  DocumentQuotation = 62,
  DocumentInvoice = 63,
  DocumentReceipt = 64,
  DocumentTaxInvoice = 65,
  DocumentPurchaseOrder = 66,
  DocumentExpense = 67,
  DocumentBillingNote = 68,
  DocumentBillingNoteExpense = 69,
  DocumentCreditNote = 70,
  DocumentCreditNoteExpense = 71,
  DocumentPurchaseTaxInvoice = 72,
  DocumentWithholdingTax = 73,
  ImportTransactionPurchaseInventory = 74,
  ImportTransactionExpense = 75,
  ImportTransactionInvoice = 76,
  ImportTransactionReceipt = 77,
  ImportTransactionQuotation = 78,
  ImportTransactionPurchaseOrder = 79,
  Statement = 80,
  AllReportWithHoldingTaxPND2 = 81,
  AllReportWithHoldingTaxPND3 = 82,
  AllReportWithHoldingTaxPND53 = 83,
  ChequeReport = 84,
  WorkingPaper = 85,
  RecalCostOfGoodSoldByMerchantCalculated = 86,
  RecalCostOfGoodSoldByProductCalculated = 87,
  RecalCostOfGoodSoldFailed = 88,
  DebitNote = 89,
  DocumentDebitNote = 90,
  DebitNoteExpense = 91,
  DocumentDebitNoteExpense = 92,
  VoidImportTransactionFailed = 93,
  TrialBalanceSeperateMonth = 94,
  VoidImportTransactionSuccess = 95,
  ImportTransactionReceiptFromInvoice = 96,
  ImportTransactionJournal = 97,
  DepreciateAssetMonthly = 98,
  TaxPnd = 99,
  TaxPP30SaleTax = 100,
  TaxPP30PurchaseTax = 101,
  TaxFetchPP30Transaction = 102,
  TaxFetchWhtCertificate = 103,
  AllReportPurchaseTaxInvoiceNotUseFromPeakTax = 104,
  AllReportSalesTaxInvoiceNotUseFromPeakTax = 105,
  AllReportTaxInvoiceFromPeakTax = 106,
  AllReportPurchaseTaxInvoiceFromPeakTax = 107,
  AllReportPurchaseTaxInvoiceNotUseFromOldPeak = 108,
  AllReportSalesTaxInvoiceNotUseFromOldPeak = 109,
  AllReportTaxInvoiceFromOldPeak = 110,
  AllReportPurchaseTaxInvoiceFromOldPeak = 111,
  FinanceBankStatement = 112,
  ExecutiveSummary = 113,
  StatementOfCashflow = 114,
  RecieveBenefit = 115,
  CamPaignBeforeExpire = 116,
  BeforeExpireByDate = 117,
  QuotaExpire = 118,
}

export enum TableSorting {
  DESC = 0,
  ASC = 1,
}

export enum ParamsReloadType {
  Reload = 1,
  IsMain = 2,
}

export enum FinanceType {
  None = 0,
  InFlow = 1,
  OutFlow = 2,
}

export enum PaymentInOutFlowType {
  None = 0,
  CashIn = 1,
  CashOut = 2,
}

export enum BankType {
  None = 0,
  CurrentAccount = 1,
  SavingAccount = 2,
  FixedDeposit = 3,
}

export enum BankAccountType {
  Cash = 0,
  Bank = 1,
  ExpenseClaim = 2,
  WithheldTax = 3,
  WithholdingTax = 4,
  EWallet = 5,
}

export enum CustomDashboardType {
  None = 0,
  Compare = 1,
  Detail = 2,
}

export enum AllocationItemGroupType {
  Single = 1,
  Group = 2,
}

export enum ExceptionCode {
  None = 0,
  CodeDuplicated = 1,
  CodeIsEmpty = 2,
  IsHaveEmployee = 3,
  IsHaveSalaryEmployee = 4,
  PasscodeInvalid = 5,
  EmailOrBankAccountNumberDuplicated = 6,
}

export enum DashboardSelectOptionType {
  None = 0,
  ThisMonth = 1,
  LastMonth = 2,
  ThisYear = 3,
  LastYear = 4,
  All = 5,
  Custom = 6,
}

export enum CustomDashboardChartPieDropdownType {
  Product = 1,
  Account = 2,
  Contact = 3,
  AccountExpense = 4,
}

export enum OverviewDashboardType {
  Daily = 1,
  Monthly = 2,
}

export enum AllocationAccountExpenseType {
  costOfSalesAndServices = 1,
  sellingExpenses = 2,
  administrativeExpense = 3,
  otherExpenses = 4,
  interestExpense = 5,
  incomeTax = 6,
}

export enum ModalCreateCustomDashboardType {
  None = 0,
  Create = 1,
  Edit = 2,
}

export enum AllocationDocumentFinanceType {
  All = 0,
  Income = 1,
  Expense = 2,
}

export enum UserType {
  Email = 0,
  Google = 1,
}

export enum IconAllocationItem {
  GraphBar1 = 1,
  Pin1 = 2,
  Star1 = 3,
  GraphBar2 = 4,
  Percentage = 5,
  Wallet = 6,
  Document = 7,
  Building = 8,
  Suitcase = 9,
  Location = 10,
  Plane = 11,
  PieChart = 12,
  MultiUsers = 13,
  Shopping = 14,
  Merchant = 15,
  Box = 16,
  MailBox = 17,
  Receipt = 18,
  Approve = 19,
  Windmill = 20,
  Lock = 21,
  Study = 22,
  Folder = 23,
  PaperPlane = 24,
  Goal = 25,
  ArrowRight = 26,
  Book = 27,
  Wrench = 28,
  Destination = 29,
  Coin = 30,
  Car = 31,
  Note = 32,
  Gift = 33,
  Education = 34,
  Handshake = 35,
  Health = 36,
  Home = 37,
  Idea = 38,
  Annouce = 39,
  Meeting = 40,
  Pint2 = 41,
  TreeChart = 42,
  Brush = 43,
  Piggy = 44,
  Achrive = 45,
  Calculator = 46,
  Subway = 47,
  Label = 48,
  Shopee = 49,
  Lazada = 50,
  Facebook = 51,
  Line = 52,
  Internet = 53,
  Laptop = 54,
}

export enum Package {
  Trial = 0,
  Free = 1,
  Basic = 2,
  Pro = 3,
  ProPlus = 4,
  AFPFree = 5,
  AFPLedger = 6,
  AFPAccountant = 7,
}

export enum DisplayDataType {
  Shorten,
  Fully,
  Gl,
}

export enum UserRight {
  None = 0,
  ViewOnly = 1,
  RevenueExpenseDraftOnly = 2,
  RevenueExpenseApproveOnly = 3,
  RevenueAll = 4,
  ExpenseAll = 5,
  QuotationOnly = 6,
  Standard = 7,
  BasicAndAdmin = 8,
  CreateRevenueOnly = 9,
  CreateExpenseOnly = 10,
  PurchaseOrderOnly = 11,
  RevenueDraftOnly = 12,
  ExpenseDraftOnly = 13,
  RevenueApproveOnly = 14,
  ExpenseApproveOnly = 15,
  QuotationDraftOnly = 16,
  QuotationApproveOnly = 17,
  PurchaseOrderDraftOnly = 18,
  PurchaseOrderApproveOnly = 19,
  ExpenseExceptPOAll = 20,
  RevenueExceptQOAll = 21,
  RevenueExpenseExceptQOandPOApproveOnly = 22,
}

export enum AuthorizeErrorCode {
  None = 0,
  Default = 1,
}
export enum TransactionErrorCode {
  None = 0,
  Default = 1,
  DuplicateNumber = 2,
  DataError = 3,
  CanNotEdit = 4,
  CanNotVoid = 5,
  DataNotFound = 6,
  TransactionTypeNotFound = 7,
}
export enum AuthorityRole {
  None = 0,
  ViewOnly = 1,
  PartialRights = 2,
  StandardRights = 3,
  Admin = 4,
}
export enum ActivityLogSource {
  None = 0,
  PEAK_Engine = 1,
  PEAK_Experience = 2,
  PEAK_API = 3,
  TransactionImport = 4,
  ZORT = 5,
  KetShopWeb = 6,
  XCommerce = 7,
  BentoWeb = 8,
  Wisible = 9,
  Empeo = 10,
  Recurring = 11,
  BoxMe = 12,
  PeakAsset = 13,
  LineConnect = 14,
  UCommerce = 15,
  Page365 = 16,
  PeakPayroll = 17,
  PeakBoard = 18,
  PeakTax = 19,
}

export enum DashBoardChartPieType {
  IncomeProduct = 1,
  ExpenseProduct = 2,
  IncomeContact = 3,
  ExpenseContact = 4,
  IncomeAccount = 5,
  ExpenseAccount = 6,
  WhereMoney = 7,
  ContactIncomeDashboard = 8,
  ContactExpenseDashboard = 9,
  ProductDetailChartBySell = 10,
  ProductDetailChartByPurchase = 11,
}
export enum FinanceAndAccountRights {
  None = 0,
  All = 1,
  FinanceAccessOnly = 2,
  GLAndStatementOnly = 3,
  DailyJournalsAll = 4,
  DailyJournalsDraftOnly = 5,
  DailyJournalsApproveOnly = 6,
  DailyJournalsAllAndFinance = 7,
  DailyJournalsDraftOnlyAndFinance = 8,
  DailyJournalsApproveOnlyAndFinance = 9,
  DailyJournalsAllAndGL = 10,
  DailyJournalsDraftOnlyAndGL = 11,
  DailyJournalsApproveOnlyAndGL = 12,
  FinanceAccountAndDailyJournalsDraftOnly = 13,
  FinanceAccountAndDailyJournalsApproveOnly = 14,
  FinanceAndGL = 15,
}
export enum DailyJournalsRightType {
  None = 0,
  DraftOnly = 1,
  ApproveOnly = 2,
  All = 3,
}
export enum ExecutiveSummaryStatus {
  None = 0,
  Draft = 1,
  Approve = 2,
}
export enum ExecutiveSummaryTransactionItemType {
  None = 0,
  OperationIncome = 1,
  CostsOfSales = 2,
  GrossProfit = 3,
  Expenses = 4,
  CostOfFinancing = 5,
  TaxRevenues = 6,
  NetProfit = 7,
  CashReceived = 8,
  CashSpent = 9,
  GainsInForeignExchange = 10,
  NetCashReceived = 11,
  CashBalance = 12,
  AccountsReceivable = 13,
  Inventory = 14,
  AccountsPayable = 15,
  QuickRatio = 16,
  InventoryTurnOver = 17,
  ReceivablesTurnOver = 18,
  AccountPayableTurnOverRatio = 19,
  AveragePaymentPeriod = 20,
  AverageInventoryPeriod = 21,
  AverageCollectionPeriod = 22,
  CashConversionCycle = 23,
  QuotationNumberIssued = 24,
  QuotationNetAmountIssued = 25,
  QuotationAverageIssued = 26,
  InvoiceNumberIssued = 28,
  InvoiceNetAmountIssued = 29,
  InvoiceAverageIssued = 30,
  GrossProfitRatio = 31,
  NetProfitMargin = 32,
  TotalAssetTurnOver = 33,
  TotalEquityTurnOver = 34,
  EquityMultiplier = 35,
  ROA = 36,
  ROE = 37,
}
export enum ExecutiveSummaryTableViewStatusType {
  All = 0,
  Draft = 1,
  Approved = 2,
  Voided = 3,
}
export enum ExecutiveSummaryOrderTableView {
  None = 0,
  Id = 1,
  Number = 2,
  name = 3,
  fromDate = 4,
  createDate = 5,
  createUserId = 6,
}
export enum ExecutiveSummaryStatus {
  StatusDraft = -2,
  StatusApproved = 0,
}
export enum DocumentType {
  None = 0,
  Quotation = 1,
  Invoice = 2,
  Receipt = 3,
  TaxInvoice = 4,
  CreditNote = 5,
  BillingNote = 6,
  DebitNote = 7,
  PP30 = 8,
  Pnd53 = 9,
  Pnd3 = 10,
  Dailyjournal = 11,
  WithholdingTax = 12,
  Payroll = 13,
  TaxPP30 = 14,
  TaxPND53 = 15,
  TaxPND3 = 16,
  Pnd1 = 17,
  Pnd2 = 18,
  Envelope = 19,
  ExecutiveSummary = 20,
}

export enum ExecutiveSummaryPeriodType {
  None = 0,
  Month = 1,
  Quarter = 2,
  Year = 3,
}

export enum PeakExceptionResponseCode {
  None = 0,
  TransactionNumberDuplicated = 1,
  ContactNotFound = 2,
  ProductNotFound = 3,
  AccountNotFound = 4,
  LockByPeriod = 5,
  FreePackageOverCreateTransaction = 6,
  ProPlusImportTransaction = 7,
  FullPaymentAmount = 8,
  InputFieldEmptry = 9,
  TransactionIsVoided = 10,
  OverPaid = 11,
  ProductNameAndDescriptionIsDuplicated = 12,
  ProductTemplateCodeIsDuplicated = 13,
  AccountCodeIsDuplicated = 14,
  UnitCodeIsDuplicated = 15,
  BankAccountCodeIsDuplicated = 16,
  ContactCodeIsDuplicated = 17,
  TaxIdIsDuplicated = 18,
  ContactNameIsDuplicated = 19,
  IssuedTaxInvoiceDuplicated = 20,
  PaymentIsDeleted = 21,
  ApprovedTransactionDuplicated = 22,
  AcceptedQuotationDuplicated = 23,
  CanNotVoidInvoiceIsIssuedBillingNote = 24,
  CanNotVoidInvoiceIsIssuedCreditNote = 25,
  CanNotVoidReceiptIsIssuedCreditNote = 26,
  LockByUser = 27,
  LockBySystem = 28,
  LockByIssuedPP30 = 29,
  LockBySendEtaxInvoice = 30,
  CanNotVoidQuotationIsIssuedInvoice = 31,
  CanNotVoidQuotationIsIssuedReceipt = 32,
  CanNotCreateDuplicatedReceiptFromReferenceTransaction = 33,
  IssuedDuplicatedTaxInvoice = 34,
  ReceivedTaxInvoiceVatTotalOverflow = 35,
  ReceivedTaxInvoicePreVatTotalOverflow = 36,
  UserProfileIsAlready = 37,
  EmailPasswordIncorrect = 38,
  ContactIdBelongToMerchant = 39,
  MerchantIsVerified = 40,
  ReceivedTaxInvoiceNumberDuplicated = 41,
  DuplicateNameContactGroup = 42,
  ImportTransactionExceed = 43,
  IsHaveUserInSystem = 44,
  DuplicatedReferFriends = 45,
  DuplicateFileName = 46,
  CanNotVoidInvoiceIsIssuedDebitNote = 47,
  CanNotVoidReceiptIsIssuedDebitNote = 48,
  BankAccountNotFound = 49,
  OverInvitationUser = 50,
  UserAlreadyMerchant = 51,
  MerchantPackageIsNotAddUser = 52,
  CanNotEditSuperUser = 53,
  UserUpdateEqualEditUser = 54,
  CanNotRemoveSuperUser = 55,
  CanNotRemoveUser = 56,
  DuplicatedSettingNumberIndextString = 57,
  AuthorityRoleNotPermission = 58,
  NotHavePermissionUser = 59,
  NotHavePermissionFinance = 60,
  NotHavePermissionPayroll = 61,
  NotHavePermissionPeakBoard = 62,
  ApiPartnerNotFound = 63,
  MerchantIsNotAllowDuplicateContact = 64,
  CanNotDeleteThisFinance = 65,
  CanNotVoidAllocation = 66,
  CanNotVoidAllocationItem = 67,
  CanNotIsArchivedAllocationIncome = 68,
  CanNotIsArchivedAllocationExpense = 69,
  LockByIssuedPND3 = 70,
  LockByIssuedPND53 = 71,
  CanNotEditDocumentIsIssuedFromPayroll = 72,
  CreditLimitCannontCreate = 73,
  CreditLimitWarning = 74,
  CanNotVoidPaymentIsIssuedReceipt = 75,
  InvalidDocumentPassCode = 76,
  CanNotEditInvoiceIsIssuedDebitNote = 77,
  CanNotEditInvoiceIsIssuedCreditNote = 78,
  CanNotEditJournal = 79,
  CanNotUpdateJournalStatus = 80,
  CanNotVoidProductTemplate = 81,
  ProductTemplateNameCanNotEmpty = 82,
  CanNotAddNewPriceToProductService = 83,
  ProductServicePriceNameDuplicated = 84,
  InvalidINetAuthenticationData = 85,
  AssetPurchaseDateLessThanStopAssetDepreciationDate = 86,
  PackageErrorCode = 87,
  UpgradeToPackageErrorCode = 88,
  AssetTemplateCodeDuplicated = 89,
  CanNotEditTransactionAsset = 90,
  CanNotVoidAssetTemplateBecauseAssetTemplateIssuedAsset = 91,
  CanNotVoidAssetBecauseAssetIssuedByPurchaseAsset = 92,
  CanNotVoidAssetBecauseAssetIssuedBySaleAsset = 93,
  OverLimitAsset = 94,
  BillingTransactionCurrencyNotCorrect = 95,
  DuplicatedReceiveBillingNoteNumber = 96,
  CanNotSaleAssetBecauseDoesNotSelectAssetId = 97,
  CanNotSaleAssetBecauseSaleAssetDateLessThanStopDepreciationDate = 98,
  IsNotHaveContactRevenueDepartment = 99,
  IsNotHaveContactSalary = 100,
  IsNotHaveContactSSO = 101,
  CantDoPaymentIsHaveErrorPndType = 102,
  CanNotVoidUnit = 103,
  ChequeisreceivedandChequeisclearing = 104,
  ChartOfAccountCannotDeleted = 105,
  UserIsInSystemAlready = 106,
  UserNotFound = 107,
  InvitationIncorrect = 108,
  InvitationIncorrectOrExpired = 109,
  AssetTemplateIsDeleted = 110,
  OverCreditNoteAmount = 111,
  OverPaymentCreditNoteAmount = 112,
  CanNotCreateCreditNote = 113,
  CreditNoteDateLessThanReferenceTransactionDate = 114,
  CanNotVoidTransactionIsHaveReferenceDocumentPayment = 115,
  OverPaidReferenceDocumentPayment = 116,
  IsReferenceTransactionIssuedCreditNote = 117,
  IssueCreditNoteAmountOverReferenceCreditNote = 118,
  CannotVoidPaymentHavePND = 119,
  CanNotEditTransactionIsIssuedReferencePaymentDocument = 120,
  CanNotEditTransactionIsIssuedPayment = 121,
  CanNotCreateCreditNoteBecauseTransactionRefIsIssuedDebitNote = 122,
  CanNotCreateCreditNoteBecauseTransactionRefIsNoDebt = 123,
  CanNotCreateDebitNoteBecauseTransactionRefIsIssuedCreditNote = 124,
  CanNotGotReceiptBecauseNotHavePayment = 125,
  CanNotVoidBillingNoteBecausePaid = 126,
  BillingAmountCannotBeGreaterThanOutstandingBalanceOfTheDocument = 127,
  CanNotBePaid = 128,
  AccountingFirmDeleted = 129,
  NotHaveAfpRefCode = 130,
  AccountingFirmRegisted = 131,
  NotHaveAccountingFirmMerchant = 132,
  AccountingFirmMerchantDeleted = 133,
  InvalidPage365AuthenticationData = 134,
  DuplicatedSaleAsset = 135,
  ValidateProductMustHaveAccountId = 136,
  JournalModelNotFound = 137,
  JournalAccountDescriptionIsEmptryOrNull = 138,
  ValidateAssetMustHaveAccountId = 139,
  ProPlusRecurringTransaction = 140,
  ProBillingNote = 141,
  BankAccountNumberIsAllowDuplicate = 142,
  BasicCreateJournal = 143,
  InvalidBentoWebAuthenticationData = 144,
  NotHavePurchaseAccountAndSellAccountForProductTemplate = 145,
  InvalidLineMyShopAuthenticationData = 146,
  CanNotCreateCreditNoteBecauseReferenceTransactionTypeAsset = 147,
  CanNotCreateDebitNoteBecauseReferenceTransactionTypeAsset = 148,
  AccumulatedDepreciationMustBeLessThanassetvalue = 149,
  BookValueMustBeHigherThanScrapValue = 150,
  CanNotVoidPayment = 151,
  CanNotRedeemCode = 152,
  RedeemOnbordingPromoCodeNotFound = 153,
  CantDoPaymentIsHaveErrorDeductType = 154,
  CanNotUpdateBecauseImageNotFound = 155,
  CanNotUpdateBecauseBankReferenceNotFound = 156,
  CanNotUpdateBecauseBankNumberIsHaveError = 157,
  CanNotUpdateBecauseRemarkIsOverLength = 158,
  CanNotUpdateOnlineviewPaymentChannelSettingBecauseUserroleNotAdmin = 159,
  CanNotDeleteContact = 160,
  CanNotCreateOrUpdatePaymentBankStatement = 161,
  NotFoundPaymentBankStatement = 162,
  CanNotVoidOrDeletePaymentBankStatement = 163,
  UnableToMakeBankReconciled = 164,
  UnableCreateDefaultDataMerchantSample = 165,
  DemoMerchantExist = 166,
  ProductTemplateIsNotHaveVatType = 167,
  InvalidShopeeAuthenticationData = 168,
  CanNotSetDueDateBeforeTransactionDate = 169,
  UnableToUndoBankReconciled = 170,
  UnableToAprroveBankReconciled = 171,
  NotFoundBankReconciled = 172,
  CannotEditProductAccountAndDescriptionBecauseTransactionItemNotMap = 173,
  CanNotAssignContactGroup = 174,
  CannotEditPaymentBecausePaymentItemNotMap = 175,
  MerchantIsNotAllowDuplicateContactTaxId = 176,
  TaxInvoiceNumberDuplicated = 177,
  ProCanImportBankStatement = 178,
  ProCanReconcile = 179,
  CanNotEditContactTransactionIsReferenceInvoice = 180,
  CanNotEditContactTransactionIsReferenceReceipt = 181,
  CanNotEditContactTransactionIsIssuedBillingNote = 182,
  CanNotEditContactTransactionIsReferenceQuotation = 183,
  CanNotEditContactTransactionIsReferenceBillingNote = 184,
  ReconciledAlready = 185,
  CanNotVoidBecauseJournalAccountIsReconciled = 186,
  InvalidLazadaAuthenticationData = 187,
  MerchantDeleteAlready = 188,
  MerchantNameNotEqual = 189,
  UserIsNotAdmin = 190,
  InvalidLightworkAuthenticationData = 191,
  QRPaymentSettingModelNotFound = 192,
  SCBQRPaymentCodeModelNotFound = 193,
  CanNotVoidBankCauseByHaveBankInSCBQR = 194,
  FreePackageNotAllowedSelectChartOfAccount = 195,
  FreePackageProductIsHaveMaximum = 196,
  FreePackageCannotCreateNewFinanceAccount = 197,
  FreePackageCannotCreateNewAccount = 198,
  PackageNotFound = 199,
  CanNotCreateContactHaveMaximumContact = 200,
  CanNotCreateContactPersonHaveMaximum = 201,
  FreePackageNotAllowedAttachFile = 202,
  CanNotCreateDocumentsDatingBackUpToTwoMonths = 203,
  CanNotEditJounalBecauseFreePackage = 204,
  CantPaidPaymentSCBQRCauseByBankAccountNotFound = 205,
  CanNotIssuedTaxInvoiceNotVat = 206,
  CantPaidPaymentSCBQRCauseByAccountModelNotFound = 207,
  CantPaidPaymentSCBQRCauseByQRPaymentSettingModelNotFound = 208,
  CantPaidPaymentSCBQRCauseBySettingSCBPaymentCodeModelNotFound = 209,
  CantPaidPaymentSCBQRCauseByBankAccountNotSet = 210,
  TransactionNewStatusCannotLessThanCurrentStatus = 211,
  TransactionCurrentStatusCannotBeRejected = 212,
  CanNotCreateBecauseHaveRecordZeroAmount = 213,
  CanNotCreateBecauseNotSupportMultipleBankAccount = 214,
  CanNotEditRecordDeleted = 215,
  NotHavePermissionAsset = 216,
  QuotationCreatedTransaction = 217,
  QuantityOverQuotation = 218,
  PriceOverQuotation = 219,
  CanNotEditInvoiceBecauseDocumentHasBeenReferredToOtherDocument = 220,
  ContactPersonNamePrefixOtherMaxLength = 221,
  ContactNamePrefixOtherMaxLength = 222,
  SkuCodeIsDuplicate = 223,
  CanNotEditQuantityTransactionReferenceQuotation = 224,
  CanNotEditPriceTransactionReferenceQuotation = 225,
  CanNotAddNewTransactionItemReferenceQuotation = 226,
  CanNotSendEmail = 228,
  BankReconcileIsAlready = 229,
}

export enum OnboardExecutiveSummary {
  ContentNormal = 0,
  ContentIcon = 1,
}
export enum Position {
  None = -1,
  Other = 0,
  BusinessOwner = 1,
  Bookkeeper = 2,
  Salesperson = 3,
  Admin = 4,
  Accountant = 5,
  Employee = 6,
  AccountingFirm = 7,
  Student = 8,
}

export enum BroadcastUserChannelType {
  None = 0,
  AuthenticatedNotification = 1,
  DisconnectNotification = 2,
  UpdateNotificationList = 3,
  MasterDeleteNotificationById = 4,
  UpdateNotificationCount = 5,
  MasterGetNotificationListByMerchantId = 6,
  MasterGetNotificationCountByMerchantId = 7,
  DisconnectNotificationAllTab = 8,
  ReCreateTab = 9,
  MasterSetNotificationIsSeenAll = 10,
}

export enum AuthenticatedNotification {
  Success = 1,
  Failed = 2,
}

export enum BroadcastTabChannelType {
  None = 0,
  MasterTabClose = 1,
}
